import styled from 'styled-components';

export const ButtonImage = styled.img`
  filter: brightness(0) saturate(100%) invert(41%) sepia(65%) saturate(898%) hue-rotate(180deg) brightness(87%) contrast(91%);
  width: 36px;
`;

export const Description = styled.span`
  display: inline-block;
  margin: 8px 10px 0 10px;
  white-space: normal;
`;
